var React = require('react');

function IcFacebookComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icons/ic-facebook"},React.createElement("g",{"id":"Vector"},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.5583 1.49984H1.44173V16.4998H16.5583V1.49984ZM0.608398 0.666504V17.3332H17.3916V0.666504H0.608398Z","fill":"#3E3E3E","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.917 13.9998V9.49984H11.2928L11.5175 7.49984H9.917V6.52584C9.917 6.01084 9.93025 5.49984 10.6549 5.49984H11.3889V4.06984C11.3889 4.04834 10.7584 3.99984 10.1206 3.99984C8.78853 3.99984 7.95444 4.82834 7.95444 6.34984V7.49984H6.48252V9.49984H7.95444V13.9998H9.917Z","fill":"#3E3E3E","key":1})])));
}

IcFacebookComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcFacebookComponent;

IcFacebookComponent.default = IcFacebookComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/MyTarifMobileSectionV2/images/ic-facebook.component.svg
// module id = 1627
// module chunks = 0